import React from 'react';
import { Quote } from 'lucide-react';

const testimonials = [
  {
    quote:
      'I’ve bought courses before that didn’t deliver what they promised. What I liked about Vali Courses was the clarity. The course description matched exactly what I got on Selar, and it helped me structure my Instagram and WhatsApp sales properly. I finally felt confident paying for a high-ticket course.',
    name: 'Adebayo Ogunleye',
    location: 'Lagos, Nigeria',
  },
  {
    quote:
      'As someone transitioning into data analytics, I did not want hype. I wanted something practical. Vali Courses helped me discover a Power BI course that was straight to the point and career focused. Knowing the course was reviewed before being listed made the decision easier.',
    name: 'Wanjiku Mwangi',
    location: 'Nairobi, Kenya',
  },
  {
    quote:
      'I was not looking for just another AI course. I wanted one that showed real business use cases. The way Vali Courses curated and explained the course before redirecting me to the checkout saved me time and money. It felt like guidance, not selling.',
    name: 'Kofi Mensah',
    location: 'Arizona, USA',
  },
];

const initialsFor = (name) => {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  const first = parts[0]?.[0] || '';
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return (first + last).toUpperCase();
};

const Testimonials = () => {
  return (
    <section className="bg-white">
      <div className="mx-3 md:mx-10 lg:mx-16 py-16 md:py-24">
        <div className="text-center">
          <h2 className="text-4xl md:text-4xl font-inter font-medium text-acBlack leading-[1.05]">
            Hear Directly From
            <br />
            Our
            <span className="relative inline-block ml-2">
              <span className="absolute inset-0 bg-yellow-300 rounded-full -rotate-1" />
              <span className="relative px-3">Learners</span>
            </span>
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="rounded-2xl bg-gray-50 border border-gray-100 p-7 md:p-8 flex flex-col"
            >
              <div className="w-10 h-10 rounded-full bg-white border border-gray-100 flex items-center justify-center">
                <Quote size={18} className="text-acBlack" />
              </div>

              <p className="mt-6 text-sm md:text-base text-gray-700 font-inter leading-relaxed">
                “{t.quote}”
              </p>

              <div className="mt-8 pt-6 border-t border-gray-200 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-white border border-gray-200 flex items-center justify-center text-sm font-inter font-semibold text-acBlack">
                  {initialsFor(t.name)}
                </div>
                <div>
                  <div className="text-sm font-inter font-semibold text-acBlack">{t.name}</div>
                  <div className="text-xs font-inter text-gray-500">{t.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
